<!-- Login Section -->
<div *ngIf="!companyList || companyList.length === 0" class="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
  <div class="card shadow-lg" style="max-width: 500px; width: 100%;">
    <div class="card-body p-5 text-center">
      <img src="./assets/images/logo_light.png" alt="SAP Business One" class="mb-4" style="max-width: 200px;">
      <h1 class="h3 mb-4">Welcome to SAP Integration</h1>
      <p class="text-muted mb-4">Please click the button below to log in to SAP.</p>
      <button type="button" class="btn btn-primary btn-lg px-5" (click)="login()">
        <i class="fas fa-sign-in-alt me-2"></i>Login to SAP
      </button>
    </div>
  </div>
</div>

<!-- Company Selection Section -->
<div *ngIf="companyList && companyList.length > 0 && !selectedCompanyData" class="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
  <div class="card shadow-lg" style="max-width: 600px; width: 100%;">
    <div class="card-header  text-white p-4 text-center" >
      <h2 class="h4 mb-0" >Select a Company</h2>
    </div>
    <div class="card-body p-5">
      <div class="mb-4">
        <label for="select-company" class="form-label">Choose your company</label>
        <mat-select 
          id="select-company" 
          class="form-select form-select-lg"
          [(ngModel)]="selectedCompany"
          name="company"
          (change)="onCompanyChange(selectedCompany)">
          <option *ngFor="let company of companyList" [ngValue]="company">
            {{ company.CompanyDisplayName }} ({{ company.CompanySchemaName }})
          </option>
        </mat-select>
      </div>
    </div>
  </div>
</div>

<!-- Company Details Section -->
<div *ngIf="selectedCompanyData" class="container-fluid py-5 bg-light">
  <div class="container">
    <div class="card shadow-lg">
      <div class="card-header bg-primary text-white p-4">
        <h2 class="h4 mb-0">Company Details</h2>
      </div>
      <div class="card-body p-4">
        <div class="row">
          <div class="col-md-6">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">B1UserCode</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.B1UserCode }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Company Name</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.CompanyDisplayName }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Schema Name</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.CompanySchemaName }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Version</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.Version }}</span>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Database Instance</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.DatabaseInstanceName }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Localization</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.Localization }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span class="fw-bold">Tenant ID</span>
                <span class="badge bg-light text-dark">{{ selectedCompanyData.TenantID }}</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div class="mt-4 text-center">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-outline-primary" (click)="getEntities('BusinessPartners')">
              <i class="fas fa-users me-2"></i>Get Business Partners
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="getEntities('Items')">
              <i class="fas fa-box me-2"></i>Get Items
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="getEntities('Orders')">
              <i class="fas fa-shopping-cart me-2"></i>Get Orders
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
